module.exports = __webpack_public_path__ + "img/img25.f6ff13e3.svg";